import "./ProgressStep.scss";
import { ReactComponent as TickIcon } from "../../../assets/img/icons/tick.svg";
import { ReactComponent as TrophyIcon } from "../../../assets/img/icons/finish-trophy.svg";

interface Props {
  label: string;
  percentage: 0 | 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90 | 100;
  isLastStep: boolean;
}

const ProgressStep: React.FC<Props> = ({ label, percentage, isLastStep }) => {
  const current = percentage < 100 && percentage > 0;
  const completed = percentage === 100;

  return (
    <>
      {isLastStep ? (
        <div className={`progress-step--last`}>
          <TrophyIcon />

          <div className="progress-step__label">{label}</div>
        </div>
      ) : (
        <div className={`progress-step${current ? "__current" : ""} progress-step__current--${percentage}`}>
          <div className={`progress-step__disc${completed ? "--active" : ""}`}>
            {completed && <TickIcon />}
          </div>

          <div className="progress-step__label">{label}</div>
        </div>
      )}
    </>
  );
};

export default ProgressStep;
